// store/college/course-management/store/actionTypes.js

// Purchased Courses
export const FETCH_PURCHASED_COURSES_REQUEST = 'FETCH_PURCHASED_COURSES_REQUEST';
export const FETCH_PURCHASED_COURSES_SUCCESS = 'FETCH_PURCHASED_COURSES_SUCCESS';
export const FETCH_PURCHASED_COURSES_FAILURE = 'FETCH_PURCHASED_COURSES_FAILURE';

// All Available Courses
export const FETCH_ALL_COURSES_REQUEST = 'FETCH_ALL_COURSES_REQUEST';
export const FETCH_ALL_COURSES_SUCCESS = 'FETCH_ALL_COURSES_SUCCESS';
export const FETCH_ALL_COURSES_FAILURE = 'FETCH_ALL_COURSES_FAILURE';

// Filters and UI State
export const SET_COURSE_FILTER = 'SET_COURSE_FILTER';
export const SET_COURSE_SEARCH = 'SET_COURSE_SEARCH';
export const SET_COURSE_VIEW = 'SET_COURSE_VIEW'; // 'grid' or 'list'
export const SET_SELECTED_COURSE = 'SET_SELECTED_COURSE';
export const TOGGLE_COURSE_DETAILS_MODAL = 'TOGGLE_COURSE_DETAILS_MODAL';

// Course Actions
export const PURCHASE_COURSE_REQUEST = 'PURCHASE_COURSE_REQUEST';
export const PURCHASE_COURSE_SUCCESS = 'PURCHASE_COURSE_SUCCESS';
export const PURCHASE_COURSE_FAILURE = 'PURCHASE_COURSE_FAILURE';

export const FETCH_STUDENT_ENROLLMENT_STATS_REQUEST = 'FETCH_STUDENT_ENROLLMENT_STATS_REQUEST';
export const FETCH_STUDENT_ENROLLMENT_STATS_SUCCESS = 'FETCH_STUDENT_ENROLLMENT_STATS_SUCCESS';
export const FETCH_STUDENT_ENROLLMENT_STATS_FAILURE = 'FETCH_STUDENT_ENROLLMENT_STATS_FAILURE';

export const FETCH_COURSE_ENROLLMENT_DETAILS_REQUEST = 'FETCH_COURSE_ENROLLMENT_DETAILS_REQUEST';
export const FETCH_COURSE_ENROLLMENT_DETAILS_SUCCESS = 'FETCH_COURSE_ENROLLMENT_DETAILS_SUCCESS';
export const FETCH_COURSE_ENROLLMENT_DETAILS_FAILURE = 'FETCH_COURSE_ENROLLMENT_DETAILS_FAILURE';

export const SET_ENROLLMENT_FILTER = 'SET_ENROLLMENT_FILTER';
export const SET_ENROLLMENT_SORT = 'SET_ENROLLMENT_SORT';
export const CLEAR_ENROLLMENT_DETAILS = 'CLEAR_ENROLLMENT_DETAILS';

export const RESET_COURSE_STATE = 'RESET_COURSE_STATE';
